import cloneWorkoutAction from '../clone'
import updateCurrentWorkoutAction from '../set-current'

export default function cloneAndSetWorkoutAction (params = {}) {
  return async (dispatch) => {
    const newWorkout = await dispatch(cloneWorkoutAction(params))
    dispatch(updateCurrentWorkoutAction(newWorkout))
    return newWorkout
  }
}
